import { ChangeEvent, useState } from 'react';
import { H5, P } from '../../../../../AbstractElements'
import { SavedAddress, ShippingInformation, ShippingMethod } from '../../../../../utils/Constant'
import { BillingFormProp } from '../../../../../Type/Forms/FormsLayout/FormWizardOne';
import { toast } from 'react-toastify';
import HomeAndOfficeAddress from './HomeAndOfficeAddress';
import ShippingMethods from './ShippingMethods';

const ShippingFormContent :React.FC<BillingFormProp> = ({ callbackActive }) => {
    const [radioBoxValues, setRadioBoxValues] = useState({address: "",shippingMethod: "",});
    const { address, shippingMethod } = radioBoxValues;
  
    const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
      const name = event.target.name;
      const value = event.target.value;
      setRadioBoxValues({ ...radioBoxValues, [name]: value });
    };
  
    const handleNextButton = () => {
      if (address !== "" && shippingMethod !== "") {
        callbackActive(3);
      } else {
        toast.error("Please fill all field after press next button");
      }
    };
  return (
    <>
      <H5 className="f-w-700">{ShippingInformation}</H5>
      <P className="f-light">Fill up the following information to send you the order</P>
      <div className="shipping-title">
        <H5 className="mb-2">{SavedAddress}</H5>
      </div>
      <HomeAndOfficeAddress radioBoxValues={radioBoxValues} getUserData={getUserData}/>
      <H5 className="mt-4 mb-2">{ShippingMethod}</H5>
      <ShippingMethods radioBoxValues={radioBoxValues} getUserData={getUserData} handleNextButton={handleNextButton}/>
    </>
  )
}

export default ShippingFormContent